module.exports = __webpack_public_path__ + "img/description-1.f13cb936.png";